<template>
  <div class="home">
    <view-list :list="list" type="collect" :total="total" @gallerySort="gallerySort"></view-list>
    <Footer></Footer>
  </div>
</template>

<script>
import Session from '../utils/session'
import Footer from '@/components/footer.vue'
import API from '@/service/API'
import ViewList from '@/components/viewList'
export default {
  name: 'Home',
  data(){
    return {
      list: [],
      total: 0,
      ordering: '-create_time,-vote_num',
    }
  },
  components: {
    ViewList,
    Footer
  },
  watch: {
    '$route': function() {
      this.getList()
    }
  },
  mounted(){
    this.getList()
    document.title = this.$route.meta.title
  },
  activated(){
    const scrollTop = this.$route.meta.scrollTop;
    if (scrollTop) {
      window.scrollTo(0, scrollTop)
    }
  },
  methods:{
    gallerySort(flag){
      if(flag){
        this.$data.ordering = 'create_time,vote_num';
      } else {
        this.$data.ordering = '-create_time,-vote_num';
      }
      this.$data.page = 1;
      this.$data.list = [];
      this.getList();
    },
    getList(){
      let params = {
        album: Session.get("albums"),
        ordering: this.$data.ordering
      }
      API.getCollect(params).then( data => {
        this.$data.list = data
        this.$data.total = data.length
      })
    }
  }
}
</script>